// Initialize the fill effect on .form-range sliders by updating a CSS custom property based on their value

export const initRangeSliderFill = () => {
  const sliders = document.querySelectorAll('.form-range');

  sliders.forEach((slider) => {
    // Initial update on page load
    updateSlider(slider);

    // Update whenever the slider's value changes
    slider.addEventListener('input', () => updateSlider(slider));
  });

  function updateSlider(slider) {
    const min = parseFloat(slider.min) || 0;
    const max = parseFloat(slider.max) || 100;
    const value = parseFloat(slider.value);

    // Calculate the percentage
    const progress = ((value - min) / (max - min)) * 100;

    // Update the custom property
    slider.style.setProperty('--range-progress', `${progress}%`);
  }
};
